export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/39c069bc1b50ede44068ee575a7bad6a.png";